import "./CSS/all.min.css"
import './CSS/sb-admin.css'
import { createRoot } from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom'
import React from 'react';
import './CSS/index.css';
import routes from './App';
const BrowserRouter = createBrowserRouter(routes)
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<React.StrictMode>
  <RouterProvider router={BrowserRouter}/>
</React.StrictMode>);